<template>
  <div id='problem'>
    <h2>Goldbach's Other Conjecture</h2>
    <a href="https://projecteuler.net/problem=46">https://projecteuler.net/problem=46</a>
    <h3>Thoughts</h3>
    <p>
      Unfortunately I don't see a solution besides brute force. Fortunately, the answer is not crazy large. Using a sieve
      to compute a decent number of primes helps.
    </p>
  </div>
</template>

<script>

export default {
  name: 'P046Page',
  components: {
  },
}

</script>

<style scoped>
div#problem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-flow: column;
  text-align: left;
  font-size: 1.5rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25rem;
  max-width: 90ch;
}
</style>
